<div class="logged-in">
  <p class="tick-text">
    <i class="fa fa-check"
       aria-hidden="true"></i>
    {{ 'logged_in_message' | i18next }}
  </p>
  <p class="email">{{ email }}</p>
  <a href="not-you"
     class="link"
     (click)="handleClick()">
    {{ 'not_you' | i18next }}
  </a>
</div>
